import {createAllActions, createAction} from 'web-app/util/redux/typed-action-helpers';

import type * as Types from './types';

const domain = 'INVOICE_SETTINGS';

export const {
    action: fetchInvoiceSettings,
    success: fetchInvoiceSettingsSuccess,
    failed: fetchInvoiceSettingsFailed,
} = createAllActions(
    `${domain}/FETCH_INVOICE_SETTINGS`,
    (institutionId: string) => ({
        institutionId,
    }),
    (invoiceSettings: Types.InvoiceSettings) => ({invoiceSettings}),
);

export const {action: toggleAdvanced} = createAction(
    `${domain}/FETCH_INVOICE_SETTINGS_TOGGLE_ADVANCED`,
    (show: boolean) => ({
        show,
    }),
);

export const {
    action: updateInvoiceSettings,
    success: updateInvoiceSettingsSuccess,
    failed: updateInvoiceSettingsFailed,
} = createAction(`${domain}/UPDATE_INVOICE_SETTINGS`, (institutionId: string, settings: Types.InvoiceSettings) => ({
    institutionId,
    settings,
}));
